module.exports = __webpack_public_path__ + "img/DW365-198.f97e0fdf.jpg";